import Vue from 'vue'
import { Getter, Action, Mutation } from 'vuex-class'
import { Component } from 'vue-property-decorator'
import Modal from '@/components/modalBase/modalBase'
import { VueTelInput } from 'vue-tel-input'

@Component({
  components: {
    Modal,
    VueTelInput
  }
})
export default class Login extends Vue {

  @Action action_postLogin: any;
  @Action action_postSignup: any;
  @Action action_putUserOnly: any;
  @Action action_postResetPassword: any;

  @Getter getUser: any
  @Getter getCountries: any
  @Getter getPathTemporal: any
  @Getter getCountry: any
  @Mutation PATH_TEMPORAL: any

  isLoadBtn = false;
  isLogin = false;
  showPassword = false
  showReset = false
  country = {
    'id': 25,
    'name': 'puebla',
    'country_code': 'mx',
    'language': 'es-MX',
    'currency': 'MXN'
  }
  cellphone = ''
  formRegister = {
    first_name: '',
    last_name: '',
    cellphone: '',
    email: '',
    password: '',
    country_id: null
  }
  formLogin = {
    email: '',
    password: ''
  }
  formReset = { email: '' }

  msgError = ''
  configInputTel = {
    defaultCountry: "co",
    onlyCountries:['co','mx', 'pe', 'ar', 'bs', 'bb', 'bz', 'bo', 'br', 'ca', 'cl', 'cr', 'cu', 'dm', 'ec', 'sv', 'us', 'gt', 'gy', 'ht', 'jm', 'ni', 'pa', 'py', 'do', 'kn', 'vc', 'lc', 'sr', 'tt', 'uy', 've' ],
    validCharactersOnly: true
  }

  acceptTermsAndConditions        = false

  mounted() {
    this.country = this.getCountry
  }

  async _register (e: any) {
    // @ts-ignore
    this.$ga.event('Login', 'Registro', 'Email')

    try {
      this.isLoadBtn = true

      const data = {
        ...this.formRegister,
        ...{ country_id: this.country.id }
      }
      await this.action_postSignup(data)
      this.formLogin = {
        email: this.formRegister.email,
        password: this.formRegister.password
      }
      this._login()
      this._routeLogin()

      this.isLoadBtn = false
    } catch (error) {
      this.isLoadBtn = false
      const status = error && error.response && error.response.status;
      if (status >= 500) {
        this.$swal({
          title: 'Error en el registro con email.',
          text: `Problemas con el servidor. Error ${status}`
        })
//        let message = 'Ayuda! \nMe está saliendo un error con el servidor.';
//        (window as any).Intercom('showNewMessage', message)
      } else {
        this.$swal({
          title: 'Error en el registro con email.',
          text: error.response.data.message
        })
      }
    }
  }
  async _login () {
    try {
      // @ts-ignore
      this.$ga.event('Login', 'Login', 'Email')
      this.isLoadBtn = true

      await this.action_postLogin(this.formLogin)
      this._routeLogin()

      this.isLoadBtn = false
    } catch(error) {
      // revismos si llego un error por el usuario
      this.isLoadBtn = false
      const status = error && error.response && error.response.status
      if (status >= 500) {
        this.$swal({
          title: 'Error al intentar entrar por email.',
          text: `Problemas con el servidor. Error ${status}`
        })
//        let message = 'Ayuda! \nMe está saliendo un error con el servidor.';
//        (window as any).Intercom('showNewMessage', message)
      } else {
        this.$swal({
          title: 'Error al intentar entrar por email.',
          text: error.response.data.message
        })
      }
    }
  }
  async _reset () {
    try {
      this.isLoadBtn = true
      await this.action_postResetPassword(this.formReset)
      this.isLoadBtn = false
      this.showReset = false
      this.$swal({
        imageUrl: '/assets/images/ui/cohete.png',
        imageWidth: 100,
        text: 'Se envió la información a su email'
      })
    } catch (error) {
      const status = error && error.response && error.response.status
      this.showReset = false
      if (status >= 500) {
        this.$swal({
          title: 'Error al intentar recuperar contraseña.',
          text: `Problemas con el servidor. Error ${status}`
        })
//        let message = 'Ayuda! \nMe está saliendo un error con el servidor.';
//        (window as any).Intercom('showNewMessage', message)
      } else {
        this.$swal({
          title: 'Error al intentar recuperar contraseña.',
          text: error.response.data.message
        })
      }
    }
  }

  _selectCellphone (number, isValid, country) {
    if (isValid.valid) {
      this.msgError = ''
      const cellphone = isValid.number.e164.replace(/[.*+?^${}()|\s\-[\]\\]/g, '')
      this.formRegister.cellphone = cellphone
    } else {
      this.msgError = 'Por favor escribir un número valido'
    }
  }

  _routeLogin () {
    if (this.getPathTemporal) {
      this.$router.push(this.getPathTemporal)
      this.PATH_TEMPORAL(null)
    } else {
      this.$router.push({ name: 'root' })
    }
  }

  _toggleReset () {
    this.showReset = !this.showReset
  }
}
